<template>
  <SimpleLifePlanningRow>
    <template #age>
      <ListItemYear :row="row" :current-age="currentAge" />
    </template>
    <template #balance>
      <ListItemBalance :row="row" />
    </template>
    <template #assets>
      <ListItemRemainingAssets :row="row" />
    </template>
  </SimpleLifePlanningRow>
</template>

<script setup lang="ts">
import ListItemBalance from './ListItemBalance.vue'
import ListItemRemainingAssets from './ListItemRemainingAssets.vue'
import ListItemYear from './ListItemYear.vue'
import SimpleLifePlanningRow from './SimpleLifePlanningRow.vue'

defineProps<{
  row: {
    deltaYear: number
    remainingAssets: number
    monthlyBalance: number
    educationCost: number
    events: string[]
  }
  currentAge: number
}>()
</script>
